export const parseClinicId = (rawClinicId: string): { providerId: string, clinicId: string } => {
  const [providerId, clinicId] = rawClinicId.split("/")[2]?.split(":") || [];

  return { providerId, clinicId }
}
